
import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Pagination from "@material-ui/lab/Pagination";
import axios from "axios";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import CircularProgress from "@material-ui/core/CircularProgress";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import VisibilityIcon from "@material-ui/icons/Visibility";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import Loader from "../Global/Loader/Index";
import AlertMessage from "../../components/Global/Message/Alert";

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles((theme) => ({
    icon: {
        float: "left",
    },
    btn: {
        padding: theme.spacing(1.2),
        backgroundColor: "transparent",
        fontWeight: "700",
        maxWidth: "230px",
        borderRadius: "10px",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "transparent",
            boxShadow: "none",
        },
        color: "#3B3B3B",
        width: "100%",
    },
    btnSearch: {
        backgroundColor: "#417557",
        fontWeight: "700",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#417557",
        },
        color: "#fff",
    },
    grayBox: {
        backgroundColor: "#F3F3F3",
    },
    grayerBox: {
        backgroundColor: "#DFDFDF",
    },
    paperNoBg: {
        backgroundColor: "transparent",
    },
    cursor: {
        cursor: "pointer",
    },
    btnRed: {
        backgroundColor: "#950000",
        boxShadow: "none",

        "&:hover": {
            backgroundColor: "#950000",
        },
        color: "#fff",
    },
}));

const ManageUsers = () => {
    const classes = useStyles();
    const [pageLoading, setPageLoading] = React.useState(true);
    // productList,newProduct,managingCategory
    const [productId, setProductId] = useState(null);
    const [usersList, setUsersList] = useState({});
    const [open, setOpen] = React.useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pages, setPages] = useState(1);
    const [id, setId] = useState(0);
    const [btnLoading, setBtnLoading] = useState(false);
    const [status, setStatus] = useState(false);
    const [alert, setAlert] = useState({
        open: false,
        type: "success",
        message: "",
    });
    const [fullName, setFullName] = useState("");
    const [mobileNumber, setMobileNumber] = useState("");
    const [role, setRole] = useState("");
    const [userId, setUserId] = useState("");
    const [userStatus, setUserStatus] = useState(false);
    const [dataUser, setDataUser] = useState({});

    const [searchValue, setSearchValue] = useState("");
    const toggleCloseAlert = () => {
        setAlert({ open: false, type: alert.type, message: alert.message });
    };

    const toggleOpenAlert = (Type, msg) => {
        setAlert({
            open: true,
            type: Type,
            message: msg,
        });
    };

    const handleClickOpen = (id, name, number, role, userState) => {
        setUserId(id);
        setFullName(name);
        setMobileNumber(number);
        setRole(role);
        setUserStatus(userState);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setUserId("");
        setFullName("");
        setMobileNumber("");
        setRole("");
        setUserStatus("");
    };


    const searchUsers = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/accounts/userlist?pageId=${currentPage}&PhoneNumber=${searchValue}`,
                config
            );
            if (data.status === "ok") {
                setUsersList(data.data.users);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    const searchUsersPaginate = async (value) => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/accounts/userlist?pageId=${value}&PhoneNumber=${searchValue}`,
                config
            );
            if (data.status === "ok") {
                setUsersList(data.data.users);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    const updateUser = async () => {
        setBtnLoading(true);
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.post(
                '/api/admin/accounts/userupdate',
                { UserId: userId, FullName: fullName, PhoneNumber: mobileNumber, Role: role, Status: userStatus },
                config
            );
            if (data.status === "ok") {
                toggleOpenAlert("success", "اطلاعات کاربر با موفقیت بروزرسانی شد");
                handleClose();
                getUsers();
                setBtnLoading(false);
            } else {
                toggleOpenAlert("error", "خطا در تغییر اطلاعات ");
                handleClose();
                setBtnLoading(false);
            }
        } catch (e) {
            console.log(e);
            toggleOpenAlert("error", "خطا در ارتباط با سرور");
            handleClose();
            setBtnLoading(false);
        }
    };

    const getUsers = async () => {
        setPageLoading(true)
        const config = {
            headers: {
                Authorization: `Bearer ` + localStorage.getItem("token"),
                "Content-Type": "application/json",
            },
        };
        try {
            const { data } = await axios.get(
                `/api/admin/accounts/userlist?pageId=${currentPage}`,
                config
            );
            if (data.status === "ok") {
                setDataUser(data)
                setUsersList(data.data.users);
                setPages(data.data.totalPages);
            }
        } catch (e) {
            console.log(e);
        }
        setPageLoading(false)
    };

    useEffect(() => {
        getUsers();
    }, []);

    return (
        <>
            <Box borderRadius={10} mt={2} mr={2} pb={1} className={classes.grayBox}>
                <Box mt={2} mb={2} px={2} pt={2}>
                    <Grid container>
                        <Grid item xs={7}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="شماره تلفن"
                                onChange={(e) => setSearchValue(e.target.value)}
                            />
                        </Grid>

                        <Grid item xs={5}>
                            <Box pl={2}>
                                <Button
                                    onClick={searchUsers}
                                    className={classes.btnSearch}
                                    fullWidth
                                    color="seconday"
                                    variant="contained"
                                >
                                    <SearchIcon />
                  جستجو
                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                <Box px={2} mt={1}>
                    <Box
                        bgcolor="#950000"
                        borderRadius={10}
                        color="#fff"
                        p={2}
                        textAlign="center">
                        <Grid container>
                            <Grid xs={1}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    ردیف
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    نام و نام خانوادگی
                                </Box>
                            </Grid>
                            <Grid xs={3}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    شماره همراه کاربر
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box justifyContent="center" alignItems="center" height="100%">
                                    سطح دسترسی
                                </Box>
                            </Grid>
                            <Grid xs={2}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    تاریخ عضویت
                                </Box>
                            </Grid>
                            <Grid xs={1}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    بلاک
                                </Box>
                            </Grid>
                            <Grid xs={1}>
                                <Box
                                    display="flex"
                                    justifyContent="center"
                                    alignItems="center"
                                    height="100%">
                                    عملیات
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                    {(pageLoading) ? (
                        <Box mt={3}>
                            <Loader text="در حال بارگزاری..." />
                        </Box>
                    ) : (
                        usersList.length > 0 ? (
                            (usersList.map((item, i) => (
                                <Box
                                    style={{ padding: "25px 15px 25px 15px" }}
                                    bgcolor="#fff"
                                    borderRadius={10}
                                    boxShadow="-4px 4px 18px rgba(0, 0, 0, 0.18)"
                                    mt={2}
                                    textAlign="center">
                                    <Grid container>
                                        <Grid xs={1}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {i + 1}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.imageURL && (
                                                    <img
                                                        src={item.imageURL}
                                                        width="30px"
                                                        height="30px"
                                                        style={{ marginLeft: "10px", borderRadius: "50%" }}
                                                    />
                                                )}{" "}
                                                {item.fullName}
                                            </Box>
                                        </Grid>
                                        <Grid xs={3}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.phoneNumber}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%"
                                                fontWeight="bold"
                                                color={item.role === "admin" ? "green" : null}>
                                                {item.role === "admin" && "مدیر"}
                                                {item.role === "user" && "کاربر عادی"}
                                            </Box>
                                        </Grid>
                                        <Grid xs={2}>
                                            {" "}
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                {item.date}
                                            </Box>
                                        </Grid>
                                        <Grid xs={1}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                <input type="checkbox" disabled checked={item.status} />
                                            </Box>
                                        </Grid>

                                        <Grid xs={1}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                height="100%">
                                                <a
                                                    onClick={() => {
                                                        handleClickOpen(
                                                            item.userId,
                                                            item.fullName,
                                                            item.phoneNumber,
                                                            item.role,
                                                            item.status
                                                        );
                                                    }}
                                                    className={classes.cursor}>
                                                    <EditIcon color="primary" />
                                                </a>

                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Box>
                            )))
                        ) : (
                            <Box mt={3} mb={1}>
                                <AlertMessage variant="info">
                                    موردی جهت نمایش وجود ندارد.
                                    </AlertMessage>
                            </Box>
                        )
                    )}
                </Box>
                <Box
                    display="flex"
                    justifyContent="right"
                    mt={3}
                    pr={3}
                    alignItems="center">
                    {!pageLoading && (`تعداد کل کاربران : ${dataUser.data.count}`)}
                </Box>
                <Box
                    display="flex"
                    justifyContent="center"
                    mt={2}
                    mb={2}
                    alignItems="center">
                    <Pagination
                        count={pages}
                        page={currentPage}
                        variant="outlined"
                        shape="rounded"
                        onChange={(e, value) => {
                            setCurrentPage(value);
                            searchUsersPaginate(value);
                        }}
                    />
                </Box>
            </Box>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description">
                <DialogTitle style={{ textAlign: 'center' }} id="alert-dialog-slide-title">
                    ویرایش کاربر ({fullName})
                </DialogTitle>
                <DialogContent style={{ minWidth: "500px" }}>
                    <DialogContentText id="alert-dialog-slide-description">

                        <TextField
                            fullWidth
                            variant="outlined"
                            value={fullName}
                            onChange={(e) => setFullName(e.target.value)}
                        />
                        <br />
                        <br />
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={mobileNumber}
                            onChange={(e) => setMobileNumber(e.target.value)}
                        />
                        <br />
                        <br />
                        <Grid spacing={-1} container>
                            <Grid xs={5}>
                                <FormControl style={{ paddingLeft: '10px' }} fullWidth variant="outlined">
                                    <InputLabel id="demo-simple-select-outlined-label">
                                        سطح دسترسی
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        name="category"
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        label="سطح دسترسی"
                                        value={role}
                                        onChange={(e) => setRole(e.target.value)}>
                                        <MenuItem disabled value="">
                                            <em> انتخاب کنید</em>
                                        </MenuItem>
                                        <MenuItem value="user">کاربری عادی</MenuItem>
                                        <MenuItem value="admin">مدیر سایت</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid xs={2}></Grid>
                            <Grid xs={5}>
                                <FormControl fullWidth variant="outlined">
                                    <InputLabel id="demo-simple-select-outlined-label">
                                        وضعیت
                                    </InputLabel>
                                    <Select
                                        fullWidth
                                        name="category"
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        label="وضعیت"
                                        value={userStatus}
                                        onChange={(e) => setUserStatus(e.target.value)}>
                                        <MenuItem disabled value="">
                                            <em> انتخاب کنید</em>
                                        </MenuItem>
                                        <MenuItem value="false">نرمال</MenuItem>
                                        <MenuItem value="true">بلاک</MenuItem>
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box
                        textAlign="center"
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                        width="100%">
                        <Button
                            variant="contained"
                            onClick={handleClose}
                            className={classes.btnRed}>
                            انصراف
                        </Button>
                        &nbsp;&nbsp;&nbsp;
                        <Button
                            onClick={updateUser}
                            color="secondary"
                            variant="contained">
                            {btnLoading ? (
                                <CircularProgress size={25} color="inherit" />
                            ) : (
                                <>اعمال تغییرات</>
                            )}{" "}
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
            <Snackbar
                open={alert.open}
                autoHideDuration={4000}
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                onClose={toggleCloseAlert}>
                <Alert onClose={toggleCloseAlert} severity={alert.type}>
                    {alert.message}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ManageUsers;